
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lzmumzmpkebtzmmljcwl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6bXVtem1wa2VidHptbWxqY3dsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MzUwNjksImV4cCI6MjA1MzExMTA2OX0.27cLIotFdNh-aYVioaD_IIfj5UXYlhPzHI2-OWY3mK4";

// Single client using the publishable (anon) key. RLS is enforced.
// Privileged admin operations are performed by edge functions (admin-users, admin-read-table)
// which validate the caller's JWT and is_admin flag server-side.
export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'supabase.auth.token',
    }
  }
);

// Backward-compat alias: any remaining code paths that imported supabaseAdmin
// will now use the regular client subject to RLS. New code must use edge
// functions for privileged operations.
export const supabaseAdmin = supabase;
